var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('the-breadcrumbs'),_c('page-content',{attrs:{"page-title":"Neue Nummer"}},[_c('emergency-number-form',{attrs:{"number":_vm.number,"submit-label":"Neue Nummer anlegen","form-submitted":_vm.saveNumber,"mode":"new"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }